import {twMerge} from '../../../common/twMerge';
import {StickyLocation} from './StickyLocation.enum';
import {StickyProps} from './StickyProps.interface';

const MOBILE_LOCATION_STYLE: {[key in StickyLocation]: string} = {
  [StickyLocation.Top]: 'sticky top-0 inset-x-0',
  [StickyLocation.Bottom]: 'sticky bottom-0 inset-x-0',
  [StickyLocation.BelowHeader]: 'sticky top-mobile_header_height_px',
};

const WEBVIEW_LOCATION_STYLE: {[key in StickyLocation]: string} = {
  ...MOBILE_LOCATION_STYLE,
  [StickyLocation.BelowHeader]: 'sticky top-0 inset-x-0',
};

const PC_LOCATION_STYLE: {[key in StickyLocation]: string} = {
  ...MOBILE_LOCATION_STYLE,
  [StickyLocation.BelowHeader]: 'sticky top-pc_header_height_px',
};

export function Sticky({
  location,
  isMobile,
  isWebView,
  className,
  ...props
}: StickyProps) {
  return (
    <div
      className={twMerge(
        'z-50',
        isMobile
          ? isWebView
            ? WEBVIEW_LOCATION_STYLE[location]
            : MOBILE_LOCATION_STYLE[location]
          : PC_LOCATION_STYLE[location],
        className
      )}
      {...props}
    />
  );
}
